var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 7.77778,
    fill: "#EE6262",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6007 13.4615C22.9413 13.789 22.9519 14.3306 22.6244 14.6712L14.7275 22.8838C14.4 23.2244 13.8584 23.235 13.5178 22.9075C13.1772 22.58 13.1666 22.0384 13.4941 21.6978L21.391 13.4852C21.7185 13.1446 22.2601 13.134 22.6007 13.4615Z",
    fill: "#EE6262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8969 22.9269C22.5628 23.261 22.0211 23.261 21.687 22.9269L13.4733 14.7136C13.1391 14.3795 13.1391 13.8378 13.4732 13.5036C13.8073 13.1695 14.349 13.1695 14.6832 13.5036L22.8969 21.7169C23.231 22.0511 23.231 22.5928 22.8969 22.9269Z",
    fill: "#EE6262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBg);
export default __webpack_public_path__ + "static/media/error-bg.115454639f892b52247f0bd590699460.svg";
export { ForwardRef as ReactComponent };